import { SolText } from '@sol/components';
import { ObjectTools } from '@sol/components/tools/object-tools';
import { Notification, NotificationType } from '@sol/components/services/notification.service';
import type { LabNotificationMood } from '../lab-notification/lab-notification.component';
import { LabAction } from '../../tools/lab-action';

export interface LabNotificationListItem {
  readonly id: string;
  readonly heading: SolText;
  readonly mood: LabNotificationMood;
  readonly action: LabAction | undefined;
  readonly dismissible: boolean;
  readonly closing: boolean;
}

export class LabNotifications {
  private constructor(public readonly notifications: readonly LabNotificationListItem[]) {}

  public static of(): LabNotifications {
    return new LabNotifications([]);
  }

  public withNotifications(notifications: readonly Notification[]): LabNotifications {
    const mapped = notifications
      .map(notification => ({
        id: notification.id,
        heading: SolText.of(notification.text, notification.textParams),
        mood: LabNotifications.toMood(notification.type),
        action: notification.action ? { text: SolText.of(notification.action.text) } : undefined,
        dismissible: notification.closeable,
        closing: notification.closedAt !== undefined,
      }))
      .reverse();
    return this.copy({ notifications: mapped });
  }

  private static toMood(type: NotificationType): LabNotificationMood {
    switch (type) {
      case 'success':
        return 'success';
      case 'warning':
        return 'warning';
      case 'error':
        return 'danger';
      case 'info':
        return 'info';
    }
  }

  private copy(props: Partial<LabNotifications>): LabNotifications {
    return ObjectTools.copy<LabNotifications>(this, props);
  }
}
